import componentSlider from "../../common/componentSlider.js";

export default () => {
  document.querySelectorAll(".js-text-card-slider").forEach((el) => {
    // Don't init slider for Image Promo Slider variant in Experience Editor
    if (document.body.classList.contains("is-page-editor")) {
      const $slider = el.find(".js-slide-container");
      $slider.show();
      return;
    }

    const config = {
      responsive: [
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
          },
        },
      ],
    };
    const breakpoint = 781;

    if (document.dir === "rtl" || el.parentElement.dir === "rtl") {
      config.rtl = true;
      el.dataset.isRtl = "true";
    }

    let activeSlider = window.innerWidth < breakpoint;

    const sliderControls = componentSlider(el, config);

    window.addEventListener("resize", () => {
      if (!activeSlider && window.innerWidth < breakpoint) {
        activeSlider = true;
        sliderControls.createSlider();
      }

      if (activeSlider && window.innerWidth >= breakpoint) {
        activeSlider = false;
      }
    });
  });
};
